var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6668 11.6667H13.3335C13.7935 11.6667 14.1668 12.04 14.1668 12.5V15.8334C14.1668 16.2934 13.7935 16.6667 13.3335 16.6667H11.6668C11.2068 16.6667 10.8335 16.2934 10.8335 15.8334V12.5C10.8335 12.04 11.2068 11.6667 11.6668 11.6667Z",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M17.4998 14.1667H14.1665",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M10.8333 14.1667H2.5",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3335 8.33331H6.66683C6.20683 8.33331 5.8335 7.95998 5.8335 7.49998V4.16665C5.8335 3.70665 6.20683 3.33331 6.66683 3.33331H8.3335C8.7935 3.33331 9.16683 3.70665 9.16683 4.16665V7.49998C9.16683 7.95998 8.7935 8.33331 8.3335 8.33331Z",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M2.5 5.83329H5.83333",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M9.1665 5.83329H17.4998",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.86f01a9d215909562dd42cb30a99d767.svg";
export { ForwardRef as ReactComponent };